import React, { useState, useEffect } from 'react';
// import * as api from '../services/api'
// import Loader from '../../components/Loader';
import deleteBin from 'assets/icons/delete.svg';
import edit from 'assets/icons/edit.svg';
import styles from 'utils/components/table-custom-v1/styles.module.css';
// import SearchBar from '../../components/SearchBar';
import PrevAndNextBtn from 'components/PrevAndNextBtn';
// import CustomizedModal from '../../components/modal/CustomizedModal';
import { useNavigate } from "react-router-dom";

import { styled, Box, Table, TextField, Typography, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, Select, MenuItem, Button, CircularProgress, Skeleton } from '@mui/material';
import moment from 'moment';
import { tableCellClasses } from "@mui/material/TableCell"
// import Nodata from "utils/components/nodata"
import Nodata from "utils/components/nodata-v1"
import { height } from '@mui/system';

import ProcessLinearCustomization from 'utils/components/processLinearCustomization'

import { ApiFindDepartment, ApiFindDropdownList } from 'utils/api/data/index'


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#478F96",
        color: "#fff",
        padding: "0px 10px !important",
        fontSize: 12,
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: "5px 10px !important",
        verticalAlign: "center",
        height: "45px"
    },
    [`&.${tableCellClasses.footer}`]: {
        backgroundColor: "#C7C7C7",
        color: "#000",
        fontSize: 12,
        padding: "2px 10px !important",
        position: "sticky",
        bottom: 0,
        zIndex: 1,
    },
}))

const StyledTableRow = styled(TableRow)(({ theme, selected }) => ({
    "&.selected": {
        backgroundColor: "#FFFF77",
    },
    "&.selected:hover": {
        backgroundColor: "#FFFF77",
    },
    "&.none-selected": {
        "&:nth-of-type(odd)": {
            backgroundColor: "#F7F7F9",
            "&:hover": {
                backgroundColor: "#ffffad",
            },
        },
        "&:nth-of-type(even)": {
            "&:hover": {
                backgroundColor: "#ffffad",
            },
        },
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}))


function TableCustom(Props) {

    const {
        head = [],
        body = [],

        more = false,
        listMore = [],
        moreIcon,
        moreText = "จัดการ",
        handlemore,
        pagination,
        header = true,

        setPage,
        rowsPerPage,
        loading = true,
        showNoData = true,
        heightNodata = "200px",
        handlelistener,
    } = Props


    const [pagging, setPagging] = useState(null)
    const [status, setStatus] = useState(loading ? false : true)
    const [data, setData] = useState(Props.data ? Props.data : [])

    const [findDepartment, setFindDepartment] = useState([])
    const [findTitleName, setFindTitleName] = useState([])


    const currentPage = pagging?.page || 1
    const totalPage = pagging?.totalPage || 1


    const page = currentPage ?? 1

    const handleNext = (length) => {
        if (page < totalPage) {
            setPage?.(page + length)
        }
    }

    const handlePrevious = (length) => {
        if (page > 1) {
            setPage?.(page - length)
        }
    }

    const fetchDepartment = async () => {
        let result = await ApiFindDepartment({ doc_status: 'W' })
        if (result && result.length > 0) {
            setFindDepartment(result)
        } else {
            setFindDepartment([])
        }
    }

    const fetchTitleName = async () => {
        let result = await ApiFindDropdownList({ source: "title_name", order: 'line_number', sort: 'desc' })
        if (result && result.length > 0) {
            setFindTitleName(result)
        } else {
            setFindTitleName([])
        }
    }



    useEffect(() => {
        fetchDepartment()
        fetchTitleName()
    }, [])

    useEffect(() => {
        if (Props.data) {
            setStatus(true)
            setPagging(Props.data?.pagging)
            setData(Props.data)
        } else {
            setData([])
            setStatus(false)
        }
    }, [Props.data])


    const CaseBody = (
        type,
        row,
        item,
        idx,
        align = "center",
    ) => {

        let result
        switch (type) {
            case "id":
                result =
                    idx + 1 + (page === 1 || page === 0 ? 0 : page - 1) * (rowsPerPage ? rowsPerPage : 0)
                break

            case 'personnel':

                result = (
                    <Box
                        sx={{
                            // display: "grid",
                            // gridTemplateColumns: "auto 1fr",
                            // gap: "10px",
                            // justifyItems: "start", // Aligns items to the start (left) of each grid cell
                            // alignItems: "center",  // Optional: aligns items vertically in the center of each grid cell
                            // height:'40px'
                            // width: '300px'
                        }}
                    >
                        <Box>
                            {row['total_user_checkup']} / {row[item.name]}
                        </Box>
                    </Box>
                )
                break

            case 'percentage':

                // console.log("percentage row : ", row);

                result = (

                    <Box>
                        {row.total_user > 0 && (row.total_user_checkup > 0 && row.total_user_checkup <= row.total_user) ? <ProcessLinearCustomization value={row.total_checkup_percentage} /> : <ProcessLinearCustomization value={0} />}
                    </Box>
                )
                break


            case 'percentage-total':

                // console.log("percentage-total row : ", row);


                result = (

                    <Box>
                        {row.total_user > 0 && (row.total_user_checkup > 0 && row.total_user_checkup <= row.total_user) ? <ProcessLinearCustomization value={row.total_user_checkup_percentage} /> : <ProcessLinearCustomization value={0} />}
                    </Box>
                )
                break

            case 'field_name':

                result = (
                    <Box sx={{ pl: 2 }}>
                        {row[item.name]}
                    </Box>
                )
                break

            case 'year':

                result = (
                    <Box sx={{ pl: 2 }}>
                        {parseInt(row[item.name]) + 543}
                    </Box>
                )
                break

            case 'edit_value':

                if (['gender', 'year', 'department_code', 'inspection_round', 'pname', 'pid'].includes(row.field)) {


                    if (row.field === 'gender') {
                        result = (

                            <Box display="flex" justifyContent="flex-end">
                                <FormControl>
                                    <Select
                                        value={row[item.name]}
                                        size="small"
                                        sx={{ width: "200px", fontSize: "14px", textAlign: "left" }}
                                        onChange={(e) => {
                                            handlelistener(e.target.value, {
                                                "name": item.name,
                                                "value": row[item.name],
                                                row: row,
                                                index: idx,
                                            });
                                        }}
                                    >
                                        <MenuItem value={'ชาย'}>ชาย</MenuItem>
                                        <MenuItem value={'หญิง'}>หญิง</MenuItem>

                                    </Select>
                                </FormControl>
                            </Box>


                        )

                    } else if (row.field === 'pid') {
                        result = (
                            <TextField
                                // disabled
                                placeholder={row[item.name]}
                                size="small"
                                value={row[item.name]}
                                style={{ width: "200px", fontSize: 14, align: 'left' }}

                                onChange={(e) => {
                                    handlelistener(e.target.value, {
                                        "name": item.name,
                                        "value": row[item.name],
                                        row: row,
                                        index: idx,
                                    })
                                }}
                            />
                        )

                    } else if (row.field === 'year') {
                        result = (

                            <Box display="flex" justifyContent="flex-end">
                                <FormControl>
                                    <Select
                                        // disabled
                                        value={row[item.name]}
                                        size="small"
                                        sx={{ width: "200px", fontSize: "14px", textAlign: "left" }}
                                        onChange={(e) => {
                                            handlelistener(e.target.value, {
                                                "name": item.name,
                                                "value": row[item.name],
                                                row: row,
                                                index: idx,
                                            });
                                        }}
                                    >
                                        <MenuItem value={'2021'}>ปี 2564</MenuItem>
                                        <MenuItem value={'2022'}>ปี 2565</MenuItem>
                                        <MenuItem value={'2023'}>ปี 2566</MenuItem>
                                        <MenuItem value={'2024'}>ปี 2567</MenuItem>
                                        <MenuItem value={'2025'}>ปี 2568</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>


                        )

                    } else if (row.field === 'inspection_round') {
                        result = (
                            <Box display="flex" justifyContent="flex-end">
                                <FormControl>
                                    <Select
                                        // disabled
                                        value={row[item.name]}
                                        size="small"
                                        sx={{ width: "200px", fontSize: "14px", textAlign: "left" }}
                                        onChange={(e) => {
                                            handlelistener(e.target.value, {
                                                "name": item.name,
                                                "value": row[item.name],
                                                row: row,
                                                index: idx,
                                            });
                                        }}
                                    >
                                        <MenuItem sx={{ textAlign: "left" }} value={'1'}>รอบตรวจ 1</MenuItem>
                                        <MenuItem sx={{ textAlign: "left" }} value={'2'}>รอบตรวจ 2</MenuItem>
                                        <MenuItem sx={{ textAlign: "left" }} value={'3'}>รอบตรวจ 3</MenuItem>
                                        <MenuItem sx={{ textAlign: "left" }} value={'4'}>รอบตรวจ 4</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>


                        )

                    } else if (row.field === 'pname') {
                        result = (

                            <Box display="flex" justifyContent="flex-end">
                                <FormControl>
                                    <Select
                                        value={row[item.name]}
                                        size="small"
                                        sx={{ width: "200px", fontSize: "14px", textAlign: "left" }}
                                        onChange={(e) => {
                                            handlelistener(e.target.value, {
                                                "name": item.name,
                                                "value": row[item.name],
                                                row: row,
                                                index: idx,
                                            });
                                        }}
                                    >
                                        {findTitleName && findTitleName.length > 0 ? findTitleName.map(d => (
                                            <MenuItem value={d.value}>{d.name}</MenuItem>
                                        )) : null}

                                    </Select>
                                </FormControl>
                            </Box>

                        )

                    } else if (row.field === 'department_code') {
                        result = (

                            <Box display="flex" justifyContent="flex-end">
                                <FormControl>
                                    <Select
                                        value={row[item.name]}
                                        size="small"
                                        sx={{ width: "200px", fontSize: "14px", textAlign: "left" }}
                                        onChange={(e) => {
                                            handlelistener(e.target.value, {
                                                "name": item.name,
                                                "value": row[item.name],
                                                row: row,
                                                index: idx,
                                            });
                                        }}
                                    >
                                        {findDepartment && findDepartment.length > 0 ? findDepartment.map(d => (
                                            <MenuItem value={d.department_code}>{d.department_name}</MenuItem>
                                        )) : null}

                                    </Select>
                                </FormControl>
                            </Box>

                        )

                    }else {
                        result = (
                            null
                        )
                    }


                } else {

                    result = (
                        <TextField
                            placeholder={row[item.name]}
                            size="small"
                            value={row[item.name]}
                            style={{ width: "200px", fontSize: 14, align: 'left' }}

                            onChange={(e) => {
                                handlelistener(e.target.value, {
                                    "name": item.name,
                                    "value": row[item.name],
                                    row: row,
                                    index: idx,
                                })
                            }}
                        />
                    )
                }

                break





            // case "profile":
            // 	let bg
            // 	let color
            // 	switch (row.gender) {
            // 		case "F":
            // 			bg = "rgba(255, 77, 73, 0.12)"
            // 			color = "rgb(255, 77, 73)"
            // 			break
            // 		case "M":
            // 			bg = "rgba(38, 198, 249, 0.12)"
            // 			color = "rgb(38, 198, 249)"
            // 			break
            // 		default:
            // 			bg = "rgba(114, 225, 40, 0.12)"
            // 			color = "rgb(114, 225, 40)"
            // 			break
            // 	}


            // 	const FirstName = row.fname
            // 		? row.fname.slice(0, 1) === "-" || row.fname.slice(0, 1) === "*"
            // 			? ""
            // 			: row.fname.slice(0, 1)
            // 		: ""
            // 	const LastName = row.lname
            // 		? row.lname.slice(0, 1) === "-" || row.lname.slice(0, 1) === "*"
            // 			? ""
            // 			: row.lname.slice(0, 1)
            // 		: ""

            // 	result = (
            // 		<Box
            // 			sx={{
            // 				display: "grid",
            // 				gridTemplateColumns: "auto 1fr",
            // 				gap: "10px",
            // 				textAlign: "left",
            // 				justifyContent: align,
            // 			}}
            // 		>
            // 			{row.image_url ? (
            // 				<Box
            // 					sx={{
            // 						display: "flex",
            // 						width: "30px",
            // 						height: "30px",
            // 						borderRadius: "100%",
            // 						boxShadow: `0px 0px 2px 1px ${color}`,
            // 					}}
            // 				>
            // 					{/* <Image
            // 						src={row.image_url}
            // 						width={30}
            // 						height={30}
            // 						style={{ borderRadius: "100%" }}
            // 					/> */}
            // 				</Box>
            // 			) : (
            // 				<Box
            // 					sx={{
            // 						width: "30px",
            // 						height: "30px",
            // 						borderRadius: "100%",
            // 						display: "flex",
            // 						justifyContent: "center",
            // 						alignItems: "center",
            // 						fontWeight: 600,
            // 						backgroundColor: bg,
            // 						color: color,
            // 					}}
            // 				>
            // 					{FirstName || LastName ? `${FirstName} ${LastName}` : "-"}
            // 				</Box>
            // 			)}
            // 			<Box>
            // 				<div>{`${row[item.name]}`} </div>
            // 				<div>{row.doc_status === 'N' ? <span style={{ color: 'green' }}>สมัครเมื่อ {moment(row.register_date).locale('th').format('D MMM YYYY')}</span> : null}</div>
            // 				<div style={{ lineHeight: "1", color: "rgba(76, 78, 100, 0.68)" }}>{row.pid}</div>
            // 			</Box>
            // 		</Box>
            // 	)
            // 	break




            // case 'ถูก':

            // 	result = (
            // 		<Box
            // 			sx={{
            // 				display: "grid",
            // 				gridTemplateColumns: "auto 1fr",
            // 				gap: "10px",
            // 				justifyItems: "start", // Aligns items to the start (left) of each grid cell
            // 				alignItems: "center",  // Optional: aligns items vertically in the center of each grid cell
            // 			}}
            // 		>
            // 			<Box>
            // 				<div
            // 					style={{
            // 						textAlign: "left",
            // 						color: row[item.name] === 'ถูก' ? '#4caf50' : '#f26c6c'
            // 					}}
            // 				>
            // 					{row[item.name]}
            // 				</div>
            // 			</Box>
            // 		</Box>
            // 	)
            // 	break

            // case 'bp':

            // 	result = (

            // 		<Box>
            // 			{row['bps']}/{row['bpd']}
            // 		</Box>


            // 	)
            // 	break

            // case 'percentage':

            // 	let precent = row['total_user'] > 0 ? (row['total_user_checkup'] / row['total_user']) * 100 : 0
            // 	result = (
            // 		<Box sx={{ display: 'flex', alignItems: 'center' }}>

            // 			<Box sx={{ minWidth: 60, pr: 2 }}>
            // 				<Typography variant='body2' color='text.secondary'>{precent.toFixed(2)} %</Typography>
            // 			</Box>
            // 			<Box sx={{ width: `${precent}%`, mr: 1 }}>
            // 				<LinearProgress variant='determinate' value={precent} />
            // 			</Box>
            // 		</Box>
            // 	)
            // 	break




            // case 'department':

            // 	result = (
            // 		<Box
            // 			sx={{
            // 				display: "grid",
            // 				gridTemplateColumns: "auto 1fr",
            // 				gap: "10px",
            // 				justifyItems: "start", // Aligns items to the start (left) of each grid cell
            // 				alignItems: "center",  // Optional: aligns items vertically in the center of each grid cell
            // 				// height:'40px'
            // 				width: '300px'
            // 			}}
            // 		>
            // 			<Box>
            // 				<div
            // 					style={{
            // 						textAlign: "left",
            // 						// color: row[item.name] === 'ถูก' ? '#4caf50' : '#f26c6c'
            // 					}}
            // 				>
            // 					{row[item.name]}
            // 				</div>
            // 			</Box>
            // 		</Box>
            // 	)
            // 	break

            // case 'personnel':

            // 	result = (
            // 		<Box
            // 			sx={{
            // 				// display: "grid",
            // 				// gridTemplateColumns: "auto 1fr",
            // 				// gap: "10px",
            // 				// justifyItems: "start", // Aligns items to the start (left) of each grid cell
            // 				// alignItems: "center",  // Optional: aligns items vertically in the center of each grid cell
            // 				// height:'40px'
            // 				// width: '300px'
            // 			}}
            // 		>
            // 			<Box>
            // 				{row['total_user_checkup']} / {row[item.name]}
            // 			</Box>
            // 		</Box>
            // 	)
            // 	break

            // case "1":

            // 	result = (
            // 		<Box
            // 			sx={{
            // 				display: "grid",
            // 				gridTemplateColumns: "auto 1fr",
            // 				gap: "10px",
            // 				justifyItems: "start", // Aligns items to the start (left) of each grid cell
            // 				alignItems: "left",  // Optional: aligns items vertically in the center of each grid cell
            // 			}}
            // 		>
            // 			<Box>
            // 				<div
            // 					style={{
            // 						// textAlign: "left",
            // 						color: row[item.name] === '1' ? '#4caf50' : '#f26c6c'
            // 					}}
            // 				>
            // 					{row[item.name]}
            // 				</div>
            // 			</Box>
            // 		</Box>
            // 	)
            // 	break

            // case "date":
            // 	result = moment(new Date(row[item.name])).format("DD-MM-YYYY")
            // 	break
            // case "newline":
            // 	result = row[item.name].map((item, index) => <div key={index}>{item}</div>)
            // 	break
            // case "time":
            // 	result = moment(row[item.name], "HH:mm:ss").format("HH:mm")
            // 	break
            // case "textfield":
            // 	result = (
            // 		<Box onClick={(e) => e.stopPropagation()}>
            // 			<TextField
            // 				value={row[item.name] || ""}
            // 				size="small"
            // 				InputProps={{ sx: { height: "30px", fontSize: "14px" } }}
            // 				inputProps={{ style: item.textAlign ? { textAlign: item.textAlign } : {} }}
            // 				onChange={(e) => handleTextField?.(e.target.value, idx, item.name)}
            // 				fullWidth
            // 			/>
            // 		</Box>
            // 	)
            // 	break
            // case "checkbox":
            // 	const NameChecked = (item.name ? `${item.name}_` : "") + "checked"
            // 	result = (
            // 		<FormControlLabel
            // 			onClick={(e) => {
            // 				if (handleCheckbox && (e.target).checked !== undefined) {
            // 					handleCheckbox(
            // 						{ ...row, [NameChecked]: (e.target).checked },
            // 						NameChecked,
            // 					)
            // 				}
            // 			}}
            // 			sx={{
            // 				alignItems: "start",
            // 				gap: "5px",
            // 				m: 0,
            // 				".MuiTypography-root": { marginTop: "5px" },
            // 			}}
            // 			control={<Checkbox sx={{ p: "5px" }} checked={row[NameChecked]} />}
            // 			label={row[item.name]}
            // 		/>
            // 	)
            // 	break
            // case "arrive":
            // 	result =
            // 		row[item.name] === "A" ? (
            // 			<Box
            // 				sx={{
            // 					color: "green",
            // 					borderRadius: "100px",
            // 					padding: "0px 5px",
            // 					backgroundColor: "rgba(114, 225, 40, 0.12)",
            // 					border: "1px solid#72e128",
            // 				}}
            // 			>
            // 				Arrived
            // 			</Box>
            // 		) : (
            // 			<></>
            // 		)
            // 	break
            // case "formatprice":
            // 	result =
            // 		item?.optionType === "textfield" ? (
            // 			<NumericFormat
            // 				size="small"
            // 				InputProps={{ sx: { height: "30px", fontSize: "14px" } }}
            // 				inputProps={{ style: item.textAlign ? { textAlign: item.textAlign } : {} }}
            // 				fullWidth
            // 				customInput={TextField}
            // 				thousandSeparator={true}
            // 				decimalScale={2}
            // 				value={row[item.name]}
            // 				onValueChange={({ floatValue }) => handleTextField?.(floatValue, idx, item.name)}
            // 			/>
            // 		) : row[item.name] === 0 || row[item.name] ? (
            // 			FormatPrice(row[item.name], item.toFixed)
            // 		) : (
            // 			""
            // 		)
            // 	break
            // case "bp":
            // 	result = row?.bp1 && row?.bp2 ? `${row.bp1}/${row.bp2}` : ""
            // 	break
            // case "search":
            // 	result = (
            // 		<Box
            // 			sx={{ display: "flex", gap: "2px", justifyContent: "center" }}
            // 			onClick={(e) => e.stopPropagation()}
            // 		>
            // 			<TextField
            // 				value={row[item.name] || ""}
            // 				size="small"
            // 				InputProps={{ sx: { height: "30px", fontSize: "14px" } }}
            // 				fullWidth
            // 				onChange={(e) => handleTextField?.(e.target.value, idx, item.name)}
            // 				disabled={item.disabled}
            // 				sx={{
            // 					"& .MuiInputBase-input.Mui-disabled": {
            // 						WebkitTextFillColor: "#000",
            // 					},
            // 				}}
            // 			/>
            // 			<IconButton sx={{ p: "2px" }} onClick={() => handleSearch?.(row[item.name])}>
            // 				<SearchIcon style={{ fontSize: "26px" }} />
            // 			</IconButton>
            // 		</Box>
            // 	)
            // 	break
            default:
                
                if (row.field === 'year'||item.name === 'year') {
                    result = `ปี ${parseInt(row[item.name]) + 543}`
                    break
                } else if (row.field === 'inspection_round') {
                    result = `รอบตรวจ ${parseInt(row[item.name])}`
                    break
                } else if (row.field === 'department_code') {
                    let department = findDepartment.find(d=>d.department_code===row[item.name])
           
                    result = department?.department_name
                    break
                } else {
                    result = row[item.name]
                    break
                }


        }
        return result
    }

    return (

        <>
            <TableContainer
                component={Paper}
            // elevation={0}
            >
                <Table aria-label="department table">
                    {header ? <TableHead>
                        <TableRow sx={{ background: '#c8ebea' }}>
                            {head && head.map((item, idx) => (
                                <TableCell
                                    key={idx}
                                    className={`${styles.head2Text} ${styles.headTable}`}
                                    align={item.align ? item.align : "center"}
                                    sx={{
                                        ...(item.minWidth && { minWidth: item.minWidth }),
                                        ...(item.width && { width: item.width }),
                                        ...(item.maxWidth && { maxWidth: item.maxWidth }),
                                        verticalAlign: "top",
                                    }}
                                >
                                    <Box><Typography sx={{ fontSize: 14, fontWeight: 600 }}>{item.name}</Typography></Box>
                                    {item.name2 ? <Typography sx={{ fontSize: 12, fontWeight: 100 }} > {item.name2}</Typography> : null}
                                </TableCell>
                            ))}

                            {(more || moreIcon) && (
                                <TableCell align={"center"}
                                    sx={{
                                        minWidth: '150px',
                                        verticalAlign: "top",
                                    }}>
                                    <Box><Typography sx={{ fontSize: 14, fontWeight: 600 }}>   {moreText}</Typography></Box>
                                </TableCell>
                            )}
                        </TableRow>

                    </TableHead> : null}

                    <TableBody>
                        {data?.data?.length > 0
                            ? data.data.map((row, rowIndex) => (
                                <StyledTableRow
                                    hover
                                    aria-rowindex={rowIndex}
                                    key={rowIndex}
                                // className={rowIndex === selected?.rowIndex ? "selected" : "none-selected"}
                                // selected={rowIndex === selected?.rowIndex}
                                // onDoubleClick={() => onSelected && handleClickSelect(row, rowIndex)}
                                // sx={{ cursor: "pointer", height: '50px' }}
                                // onContextMenu={(event) => {
                                //     handleClickPopover?.(event, row, rowIndex)
                                // }}
                                >
                                    {body.map((item, idx) => (
                                        <StyledTableCell key={idx} align={item.align ? item.align : "center"} >
                                            {CaseBody(item.type, row, item, rowIndex, item.align)}
                                        </StyledTableCell>
                                    ))}

                                    {(more || moreIcon) && (
                                        <StyledTableCell align={"center"}
                                            sx={{
                                                minWidth: '150px',
                                                verticalAlign: "top",
                                            }}>
                                            <Box>
                                                {listMore && listMore.length > 0 ? <>{listMore.map(d => (
                                                    <>
                                                        {d === 'EDIT' ? <img
                                                            src={edit}
                                                            alt="Edit"
                                                            onClick={() => handlemore?.(d, row)}
                                                            style={{
                                                                width: "18px",
                                                                height: "18px",
                                                                margin: "5px",
                                                                cursor: "pointer",
                                                            }}
                                                        /> : null}
                                                        {d === 'DELETE' ? <img
                                                            src={deleteBin}
                                                            alt="Delete"
                                                            onClick={() => handlemore?.(d, row)}
                                                            style={{
                                                                width: "18px",
                                                                height: "18px",
                                                                margin: "5px",
                                                                cursor: "pointer",
                                                            }}
                                                        /> : null}
                                                    </>
                                                ))}</> : null}

                                            </Box>
                                        </StyledTableCell>
                                    )}

                                </StyledTableRow>
                            ))
                            : showNoData && (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={100}>
                                        <Nodata height={heightNodata} />
                                    </StyledTableCell>
                                </StyledTableRow>
                            )
                        }



                        {/* {body.map((item, idx) => (
                            <StyledTableCell key={idx} align={item.align ? item.align : "center"}>
                                {CaseBody(item.type, row, item, rowIndex, item.align)}
                            </StyledTableCell>
                        ))} */}


                        {/* {list?.length === 0 ? (
                            <TableRow>
                                <TableCell className={styles.head2Text} colSpan={4} align="center" style={{ borderBottom: '1px solid transparent', paddingTop: '5pc' }}>
                                    {loading ? 'กำลังโหลดข้อมูล...' : 'ไม่มีข้อมูล'}
                                </TableCell>
                            </TableRow>
                        ) : (
                            list?.map((each) => (
                                <TableRow key={each.department_code} sx={{ borderBottom: '1px solid transparent', '&:hover': { backgroundColor: '#fafafa' } }}>
                                    <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 8px 10px 40px' }} >
                                        {each.department_name}
                                    </TableCell>
                                    <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 2px' }} align="center">
                                        {each.department_name_short}
                                    </TableCell>
                                    <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 2px' }} align="center">
                                        {each.number_of_people}
                                    </TableCell>
                                    <TableCell style={{ borderBottom: '1px solid transparent', padding: '12px 8px 8px 8px' }} align="center">
                                        <img src={edit} alt="Edit" onClick={() => handleEdit(each.department_code, each.department_name, each.department_name_short, each.number_of_people)} className={styles.modifyIcon} />
                                        <img src={deleteBin} alt="Delete" onClick={() => handleDelete(each.department_code, each.department_name)} className={styles.modifyIcon} />
                                    </TableCell>
                                </TableRow>
                            ))
                        )} */}
                    </TableBody>
                </Table>
            </TableContainer >

            <Box sx={{ marginRight: 2, marginBottom: 2 }}>
                {pagination ? <PrevAndNextBtn
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    currentPage={currentPage}
                    totalPage={totalPage}
                /> : null}

            </Box>

            {pagination ? <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 2, pb: 12, height: '120px' }}>
                หน้าที่ {currentPage} / {totalPage}
            </Box> : null}








        </>

    );
}


export default TableCustom;
